/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BonusUserSearchVo
 */
export interface BonusUserSearchVo {
    /**
     * 用户ID
     * @type {number}
     * @memberof BonusUserSearchVo
     */
    userId?: number;
    /**
     * 会员名
     * @type {string}
     * @memberof BonusUserSearchVo
     */
    userName?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof BonusUserSearchVo
     */
    userCode?: string;
    /**
     * 登录账号
     * @type {string}
     * @memberof BonusUserSearchVo
     */
    account?: string;
    /**
     * 等级id
     * @type {number}
     * @memberof BonusUserSearchVo
     */
    gradeId?: number;
    /**
     * 等级名称（等级被禁用/删除时可能为空）
     * @type {string}
     * @memberof BonusUserSearchVo
     */
    gradeName?: string;
}

/**
 * Check if a given object implements the BonusUserSearchVo interface.
 */
export function instanceOfBonusUserSearchVo(value: object): value is BonusUserSearchVo {
    return true;
}

export function BonusUserSearchVoFromJSON(json: any): BonusUserSearchVo {
    return BonusUserSearchVoFromJSONTyped(json, false);
}

export function BonusUserSearchVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusUserSearchVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'account': json['account'] == null ? undefined : json['account'],
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
        'gradeName': json['gradeName'] == null ? undefined : json['gradeName'],
    };
}

export function BonusUserSearchVoToJSON(json: any): BonusUserSearchVo {
    return BonusUserSearchVoToJSONTyped(json, false);
}

export function BonusUserSearchVoToJSONTyped(value?: BonusUserSearchVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'account': value['account'],
        'gradeId': value['gradeId'],
        'gradeName': value['gradeName'],
    };
}

